import React, { useEffect, useState } from "react";
import { Card, Container, CardBody, CardSubtitle, CardTitle, CardText, Button } from "reactstrap";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Chip from '@mui/material/Chip';
import { DataGrid } from '@mui/x-data-grid';
import { TextField, Box, IconButton } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import pieChartImg from '../../assets/images/pie-chart.svg';
import profileImg from '../../assets/images/about.jpg';
import lineChart from '../../assets/images/total-requisition.svg';
import vendorImg from '../../assets/images/line-chart 1.svg';
import vendorpurchaseImg from '../../assets/images/vendor-wise-pc.svg';


const Dashboard = () => {
    const [selectedDate, setSelectedDate] = useState(null);
    const recentcolumns = [
        {
            field: 'Sl_No',
            width: 90,
            // flex: 1,
            sortable: false,
            resizable: false,
        },
        {
            field: 'Requisition_Date',
            headerName: 'Requisition Date',
            headerClassName: 'break-header',
            // width: 120,
            flex: 1,
            editable: false,
            sortable: false,
            resizable: false,
        },
        {
            field: 'Product_Name',
            headerName: 'Product Name',
            headerClassName: 'break-header',
            cellClassName: 'product_name_wrap',
            flex: 1,
            editable: false,
            sortable: false,
            resizable: false,
        },
        {
            field: 'Status',
            headerName: 'Status',
            headerClassName: 'table-header-background',
            sortable: false,
            // width: 160,
            flex: 1,
            sortable: false,
            resizable: false,
            renderCell: (params) => {
                const status = params.value;
                // Define the color for the chip based on the status
                let chipColor = 'default';
                if (status == 'Waiting for response') {
                    chipColor = 'error'; // Red color for waiting for response
                } else if (status == 'approved') {
                    chipColor = 'success'; // Green color for approved
                }

                // Render the Chip component with the outlined variant and appropriate color
                return <Chip className="status_badge mb-1 mt-1" label={status} variant="outlined" color={chipColor} />;
            },
        },
    ];

    const recentrows = [
        { id: 1, Sl_No: 1, Requisition_Date: '29-Apr-24', Product_Name: 'HOBS HB-MARICA', Status: 'Waiting for response' },
        { id: 2, Sl_No: 2, Requisition_Date: '29-Apr-24', Product_Name: 'Chy-Freshy-( I - Clean)-M-Trade', Status: 'Waiting for response' },
    ];
   return (
    <>
<div class="dashboard_flex_container">
   <div class="large_fixed_card_holder">
     <Card className="mb-0" style={{borderRadius:'8px'}}>
               <div className="d-flex justify-content-between align-items-center approvalcard-title">
                   <div className="card_hedaerText"><p className="mb-0">Approval Status</p></div>
                   <div>
                   <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker className='dashboard_date_picker'
                            label="Date Range"
                              />
                   </LocalizationProvider>
                   </div>
               </div>
               <CardBody>
               <div>
                <img src={pieChartImg} style={{width: "100%", height:'100%', objectFit: "cover"}} />
               </div>
               </CardBody>
     </Card>
 </div>
   <div class="right_cards_holder">
     <div className="vendor_wise_card">
       <Card className="mb-0" style={{borderRadius:'8px',}}>
               <div>
                   <div className="card_hedaerText verticalcard-title"><p className="mb-0">Vendor Wise PO</p></div>
               </div>
               <CardBody>
                <div>
                    <img src ={vendorImg} style={{width: "100%", height:'100%', objectFit: "cover"}} />
                </div>
               </CardBody>
        </Card>
        </div>
        <div className="purchase_holder_card">
        <Card className="mb-0" style={{borderRadius:'8px',}}>
               <div>
                   <div className="card_hedaerText verticalcard-title">
                    <p className="mb-0">Vendor Wise Purchase cost</p>
                    </div>
               </div>
               <CardBody>
               <div>
                <img src ={vendorpurchaseImg} style={{width: "100%", height:'100%', objectFit: "cover"}} />
               </div>
               </CardBody>
        </Card>
    </div>
    </div>
    <div class="large_fixed_card_holder">
           <Card className="mb-2" style={{borderRadius:'8px'}}>
                <CardBody>
                   <div className="d-flex justify-content-between align-items-center">
                       <div className="card_hedaerText"><p className="mb-0">Total Requisition</p></div>
                       <div>
                       <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker className='dashboard_date_picker'
                            label="Date Range"
                              />
                       </LocalizationProvider>
                       </div>
                   </div>
                   <div>
                    <img src={lineChart} style={{width: "100%", objectFit: "cover"}} />
                   </div>
                   </CardBody>
            </Card>
 </div>
 <div class="right_cards_holder">
 <Card className="mb-2" style={{borderRadius:'8px'}}>
                 <CardBody>
                    <div className="d-flex justify-content-between align-items-center">
                       <div className="card_hedaerText"><p className="mb-0">Recent Requisition</p></div>
                       <div>
                       <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker className='dashboard_date_picker'
                            label="Date Range"
                              />
                       </LocalizationProvider>
                       </div>
                       </div>
                       <div className="mt-2">
                           <DataGrid
                               className="table_header_background dashboard_table_design"
                               headerClassName="custom-header-cell"
                               getRowHeight={() => 'auto'}
                               rows={recentrows}
                               columns={recentcolumns}
                               initialState={{
                                   pagination: {
                                       paginationModel: {
                                           pageSize: 5,
                                       },
                                   },
                               }}
                               pageSizeOptions={[5]}
                               disableRowSelectionOnClick
                               disableColumnMenu
                               componentsProps={{
                                   cell: {
                                       disableClick: true,
                                   },
                               }}
                               sx={{
                                   '& .MuiDataGrid-cell': {
                                       '& .MuiDataGrid-cell--textOverflow': {
                                           overflow: 'hidden',
                                           textOverflow: 'ellipsis',
                                           whiteSpace: 'nowrap',
                                       },
                                   },
                               }} />
                       </div>
                       </CardBody>
                    </Card>
 </div>
 </div>
    </>
    );
};

export default Dashboard;
